<script lang="ts">
    function share() {
        if (navigator.share) {
            navigator
                .share({
                    title: "TextCloaker",
                    text: "Cloak your AI-generated text with TextCloaker!",
                    url: window.location.href,
                })
                .then(() => console.log("Successful share"))
                .catch((error) => console.error("Error sharing:", error));
        } else {
            // console.error("Web Share API not supported.");
            // copy url
            navigator.clipboard.writeText(window.location.href);
        }
    }
</script>

<div class="embedded-button-container">
    <div class="share">
        <sl-tooltip content="Share">
            <button on:click={share}>
                <img
                    class="shareIcon"
                    src="../shareicon.png"
                    alt="Share Icon"
                />
                <!-- <sl-icon class="shareIcon" name="share"></sl-icon> -->
            </button>
        </sl-tooltip>
    </div>
</div>